import { lazy, Suspense } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Skeleton from "@/v2-ui/skeleton"
import type { LayerUpdatePreviewMapProps } from "@/v2-backoffice-client/layer/update/preview/LayerUpdatePreviewMap"

// The map chunk drags in @arcgis/core (megabytes); only fetch it when the
// Configuration workbench actually renders the panel.
const LayerUpdatePreviewMap = lazy(
  () =>
    import("@/v2-backoffice-client/layer/update/preview/LayerUpdatePreviewMap"),
)

export type LayerUpdatePreviewProps = LayerUpdatePreviewMapProps

/**
 * The live-preview half of the Configuration split screen: renders the
 * current draft on a real map (console layer factory), full-bleed like the
 * ArcGIS playground, so misconfigurations show up before saving.
 */
function LayerUpdatePreview(props: LayerUpdatePreviewProps) {
  const { className, ...previewMapProps } = props

  return (
    <Suspense
      fallback={<Skeleton className={cn("rounded-md border", className)} />}
    >
      {/* Spread, not picked props: dropping a forwarded prop here silently
          disables map behavior (autoApplyMs once arrived and never left
          this wrapper). */}
      <LayerUpdatePreviewMap className={className} {...previewMapProps} />
    </Suspense>
  )
}

export default LayerUpdatePreview
